import React from 'react';
import PropTypes from 'prop-types';

import { SlideToggler } from 'components/core/SlideToggler';

export function TogglerSearchOnMove({ handleChange, checked }) {
	return (
		<div className="toggler-search-on-move">
			<SlideToggler
				id="toggler-search-on-move"
				label="Search When I Move the Map"
				value=""
				name="search-on-move"
				onChange={handleChange}
				checked={checked}
				extraLabel={checked ? 'Turned On' : 'Turned Off'}
			/>
		</div>
	);
}

TogglerSearchOnMove.propTypes = {
	handleChange: PropTypes.func.isRequired,
	checked: PropTypes.bool.isRequired,
};

export default TogglerSearchOnMove;
